import GeneralError from '../../pages/GeneralError';
import { ServerError } from './ServerError';
import { AxiosError, HttpStatusCode } from 'axios';
import NoAccessView from './NoAccessView';
import AboutJaaSection from '../Promotional/AboutJaaSection';
import { Stack } from '@mui/material';
import { ContentNotFound } from './ContentNotFound';
import { addEventToGTMDataLayer } from '../../utilities/gtm';
import { useEffect, useMemo } from 'react';

interface ErrorViewProps {
  apiError: AxiosError | null;
}

export default function ErrorView({ apiError }: Readonly<ErrorViewProps>) {
  const errorType = useMemo(() => {
    if (apiError === null) {
      return 'unknown_error';
    }

    if (apiError.response?.status === HttpStatusCode.NotFound) {
      return 'not_found';
    }

    if (
      apiError.response?.status === HttpStatusCode.Unauthorized ||
      apiError.response?.status === HttpStatusCode.Forbidden
    ) {
      return 'not_authorized';
    }

    if (
      apiError.response &&
      apiError.response.status >= HttpStatusCode.InternalServerError
    ) {
      return 'server_error';
    }

    return 'unknown_error';
  }, [apiError]);

  useEffect(() => {
    addEventToGTMDataLayer({
      event: 'error',
      error_reason: errorType,
    });
  }, [errorType]);

  switch (errorType) {
    case 'not_found':
      return <ContentNotFound />;
    case 'not_authorized':
      return (
        <Stack direction='column' useFlexGap spacing={6}>
          <NoAccessView />
          <AboutJaaSection />
        </Stack>
      );
    case 'server_error':
      return <ServerError />;
    default:
      return <GeneralError />;
  }
}
